var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19581 15.7033C8.09853 15.7784 7.97728 15.8156 7.85463 15.8079C7.73199 15.8002 7.61631 15.7483 7.52914 15.6617L6.62914 14.7617C6.54349 14.676 6.49136 14.5625 6.48219 14.4418C6.47301 14.321 6.50741 14.2009 6.57914 14.1033L10.4958 10.1867L6.57914 6.27C6.50724 6.17246 6.47275 6.05237 6.48192 5.93155C6.4911 5.81073 6.54334 5.69722 6.62914 5.61166L7.52914 4.71166C7.61535 4.62398 7.73046 4.57058 7.85308 4.56138C7.9757 4.55218 8.09748 4.58782 8.19581 4.66166L13.3625 9.82C13.4343 9.88796 13.4839 9.97608 13.5047 10.0728C13.5255 10.1694 13.5166 10.2701 13.4791 10.3617C13.4555 10.4333 13.4122 10.4968 13.3541 10.545",
    fill: "#4972F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.3699c2ccaa613bc3f10039f2c519008b.svg";
export { ForwardRef as ReactComponent };